"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndPointsLoginConfig = void 0;
var StateProvider_1 = require("./StateProvider");
var EndPointsLoginConfig = /** @class */ (function () {
    function EndPointsLoginConfig() {
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        this.selectedEnv = process.env.NODE_ENV || 'development'; // 'dev';
        this.gateWayMSurl = '/msapi';
        // gateWayMSurl = 'https://idse2.dev.att.com:10081/msapi';
        this.authenticateAndLogin = this.gateWayMSurl + '/login/unauth/service/v1/authenticateAndLogin';
        this.getUserCurrentState = this.gateWayMSurl + '/login/unauth/service/v1/getUserCurrentState';
        this.validatePasscode = this.gateWayMSurl + '/login/unauth/service/v1/validatePasscode';
        this.validatePasscodeV2 = this.gateWayMSurl + '/profile/passcode/v2/validate';
        this.invalidateSession = this.gateWayMSurl + '/login/unauth/service/v1/invalidateSession';
        this.toggleApi = this.gateWayMSurl + '/ixp-allocation-manager-service/v1/allocations';
        this.validateLoginToken = this.gateWayMSurl + '/login/unauth/service/v1/validateLoginToken';
        this.profileSessionRefresh = this.gateWayMSurl + '/profile/v1/user/session/refresh';
        this.inFocus = this.gateWayMSurl + '/infocus';
        this.headers = [
            {
                name: 'Accept',
                value: 'application/json,*/*',
            },
        ];
    }
    EndPointsLoginConfig.prototype.getInitialHeaders = function () {
        var defaultHeaders = new Headers();
        this.headers.forEach(function (header) {
            defaultHeaders.append(header.name, header.value);
        });
        var stateCsrfToken = this.stateManager.get('appShell', 'csrf-token');
        if (stateCsrfToken && stateCsrfToken.value) {
            defaultHeaders.append('X-CSRF-TOKEN', stateCsrfToken.value);
        }
        return defaultHeaders;
    };
    return EndPointsLoginConfig;
}());
exports.EndPointsLoginConfig = EndPointsLoginConfig;
exports.default = new EndPointsLoginConfig();
//# sourceMappingURL=EndPointsLoginConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/EndPointsLoginConfig.js
// module id = 1497
// module chunks = 8